import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

interface DatadogConfig {
  clientToken: string;
  site: string;
  service: string;
  env: string | undefined;
  sampleRate: number;
  silentMultipleInit: boolean;
}

interface RUMConfig extends DatadogConfig {
  applicationId: string;
  trackUserInteractions: boolean;
}

interface LogsConfig extends DatadogConfig {
  forwardErrorsToLogs: boolean;
  telemetrySampleRate: number;
}

const baseConfig: DatadogConfig = {
  clientToken: process.env.GATSBY_DATADOG_CLIENT_TOKEN || '',
  site: 'datadoghq.com',
  service: 'blog',
  env: process.env.GATSBY_ENV,
  sampleRate: 100,
  silentMultipleInit: true,
};

const initializeDatadog = (): void => {
  // Initialize RUM
  const rumConfig: RUMConfig = {
    ...baseConfig,
    applicationId: process.env.GATSBY_DATADOG_APPLICATION_ID || '',
    trackUserInteractions: true,
  };
  datadogRum.init(rumConfig);

  // Initialize Logs
  const logsConfig: LogsConfig = {
    ...baseConfig,
    forwardErrorsToLogs: true,
    telemetrySampleRate: 0,
  };
  datadogLogs.init(logsConfig);
};

export default initializeDatadog;
